/*
* success : 请求成功执行的函数
* fail：请求失败执行的函数
*
* */
import http from '@/service/http';
import axios from 'axios';
//有的请求需要用户认证，视情况而定
const getConfig = function (auth) {
  let config = {}
  if(auth){
    config.headers={
      "Authorization": auth
    }
  }
  return config;
}
var request = {
  get:function (url,auth,success,fail) {
    return http.get(url,getConfig(auth))
      .then(function (res) {
        success(res);
      })
      .catch(function (error) {
        if(fail){
          fail(error);
        }
        console.log(error);
      })
  },
  post:function (data,url) {
  //function (url,data,auth,success,fail)
//   console.log(data)
   data = data + '&device_source=tj';
    return axios({
      method: 'post',
      url:url,
      data:data
    }).then((res)=>{
      return res
    });
  },
  put:function (url,data,auth,success,fail) {
    return http.put(url,data,getConfig(auth))
      .then(function (res) {
        success(res);
      })
      .catch(function (error) {
        if(fail){
          fail(error);
        }
        console.log(error);
      })
  },
}
export default  request;



// WEBPACK FOOTER //
// ./src/service/request.js